module.exports = function getResource(label) {
    let resources = {
        creditLimit: 'Credit Limit:',
        viewDetails: 'View Details',
        certonaCarouselTitle: 'certona carousel',
        continueShoppingButton: 'Continue Shopping',
        certonaSubHead: 'Give these a try...'
    };

    return resources[label];
};
